import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const Card = ( props ) => {
    return (
        <div className="statspro-card">
            { props.children }
            <div className="statspro-card__background"></div>
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.node.isRequired
};